<template>
  <b-card>
    <donation-groups />
    <title-name />
    <notes-text />
    <report-hidden />
    <template v-if="dataItem.id_donation_groups">
      <div class="d-flex">
        <div>
          <donation-types />
        </div>
        <div class="border-left pl-1">
          <account-types />
        </div>
      </div>
    </template>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import DonationGroups from '@/views/Admin/Donation_groups/Expenses/elements/DonationGroups.vue'
import TitleName from '@/views/Admin/Donation_groups/Expenses/elements/Title.vue'
import DonationTypes from '@/views/Admin/Donation_groups/Expenses/elements/DonationTypes.vue'
import AccountTypes from '@/views/Admin/Donation_groups/Expenses/elements/AccountTypes.vue'
import NotesText from '@/views/Admin/Donation_groups/Expenses/elements/Notes.vue'
import ReportHidden from '@/views/Admin/Donation_groups/Expenses/elements/ReportHidden.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    DonationGroups,
    TitleName,
    DonationTypes,
    AccountTypes,
    NotesText,
    ReportHidden,
  },
  computed: {
    dataItem() {
      return this.$store.getters['donationGroups/dataItem']
    },
  },
}
</script>
